<p-dialog 
    [(visible)]="visible"
    header="Review Data Sharing"
    [closable]="false"
    [modal]="true"
    [draggable]="false"
    [style]="{'max-width': '700px', width: '100%'}">

    <p [innerHTML]="dialogMessage"></p>

    <div style="display: flex; justify-content: space-between;">
        <div style="display: flex;">
            <button
                pButton
                label="Remind Me Later"
                class="p-button-tertiary mr-3"
                [disabled]="buttonUsed"
                (click)="remindMeLater()">
            </button>

            <button
                pButton
                label="Manage"
                class="p-button-tertiary"
                [disabled]="buttonUsed"
                (click)="manage()">
            </button>
        </div>
        
        <button
            pButton
            label="Agree To Share"
            class="m-button-primary"
            [disabled]="buttonUsed"
            (click)="accept()">
        </button>
    </div>
</p-dialog>